import { Member } from '~/App/shared/interfaces/Member';
import { ProcessedAuction } from '~/App/shared/interfaces/ProcessedAuction';
import {
  MONTHLY_COST_DOWNPAYMENT_PERCENT,
  MONTHLY_COST_RESIDUAL_VALUE_MONTHS,
  MONTHLY_COST_RESIDUAL_VALUE_PERCENTAGE
} from '~/config/constants';
import { calculateFinance } from '~/helpers/calculator';
import { TranslateFunction } from '~/Locale';

// TODO: Refactor this function in the future
export function getRestrictionsInfo(
  member: Member,
  isFixedPrice: boolean,
  auction: ProcessedAuction,
  hasForeignConnections: boolean,
  t: TranslateFunction
) {
  const { exportable, mustExport } = auction.processObject.properties;
  const isCompanyMember = member?.memberType === 'ORGANISATION_PERSON';
  const isHeavyEquipment = auction.processObject.properties.heavyEquipment;
  const saleLimitedToCorporate =
    auction.processObject.properties.saleLimitedToCorporate;
  const allowedToBid = auction.allowedToBid;

  if (allowedToBid)
    return {
      showRestrictionsBox: false,
      text: ''
    };

  if (isFixedPrice) {
    if (hasForeignConnections && !exportable) {
      return {
        showRestrictionsBox: true,
        text: t(
          'To buy for a fixed price is only available for customers in Sweden.'
        )
      };
    }

    if (!hasForeignConnections && exportable && mustExport) {
      return {
        showRestrictionsBox: true,
        text: t(
          'To buy for a fixed price is only available for export customers.'
        )
      };
    }

    if (!isCompanyMember && (isHeavyEquipment || saleLimitedToCorporate)) {
      return {
        showRestrictionsBox: true,
        text: t('To buy for a fixed price is only available for companies.')
      };
    }
  } else {
    // Auction

    if (hasForeignConnections && !exportable) {
      return {
        showRestrictionsBox: true,
        text: t('The bidding is only open for customer in Sweden.')
      };
    }

    if (!hasForeignConnections && exportable && mustExport) {
      return {
        showRestrictionsBox: true,
        text: t('The bidding is only open for export customers.')
      };
    }

    if (!isCompanyMember && (isHeavyEquipment || saleLimitedToCorporate)) {
      return {
        showRestrictionsBox: true,
        text: t('The bidding is only open for companies.')
      };
    }
  }

  return {
    showRestrictionsBox: false,
    text: ''
  };
}

type GetMonthlyLoanCostProps = {
  amount: number;
  interestRate: number;
  repaymentPeriod?: number;
  withResidualValue?: boolean;
};

export const getMonthlyLoanCost = ({
  amount,
  interestRate,
  repaymentPeriod = MONTHLY_COST_RESIDUAL_VALUE_MONTHS,
  withResidualValue = true
}: GetMonthlyLoanCostProps) => {
  const downPayment = amount * MONTHLY_COST_DOWNPAYMENT_PERCENT;
  const monthlyCost = amount
    ? calculateFinance({
        price: amount,
        downPayment: downPayment,
        months: repaymentPeriod,
        interestRate: interestRate,
        residualPercentage: withResidualValue
          ? MONTHLY_COST_RESIDUAL_VALUE_PERCENTAGE
          : 0
      })
    : 0;

  return monthlyCost;
};
